(ns common.schema.entities.ic-decision.core
  "Common entity-type definition of the IC investment decision. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the IC decision documents with the calculated fields."
  (:require
   [common.schema.entities.ic-decision.schema :as ic-decision]
   [common.schema.entities.ic-decision.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/ic-decision
   :schema                       ic-decision/schema
   :name                         {:en "IC investment decision"}
   :plural                       {:en "IC investment decisions"}
   :icon                         :fa-lightbulb-on
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
